import ServiceLocator from "../service-locator";
import PinnedNavModule from "./pinned-nav-module";
import MobileNavModule from "./mobile-nav-module";
import Api from "../../lib/api";
import { HeaderDropdownService } from "./header-dropdown-service";
import { throttle } from "../../lib";
import {CourseMenuLoader} from "./course-menu-loader";

export default class Header {
	constructor() {
		/* Elements */
		this.$root = document.querySelector('.site-header');
		this.$mobileNavMenuTrigger = document.getElementById('mobile-nav-menu');

		this.sl = ServiceLocator.instance;
		this.courseMenuLoader = new CourseMenuLoader();
		this.dropdownService = null;
		this.mobileNavModule = null

		this.desktopInitialized = false;
		this.mobileInitialized = false;

		this.media = window.matchMedia('(min-width: 769px)').matches;

		this.init();
	}

	init() {
		this.getUserData();
		this.bootstrap();
	}

	getUserData() {
		this.sl.userDataService.fetchLMSUserData().finally(() => {
			this.setUserAvatar();
			window.addEventListener(this.sl.userDataService.LMS_USER_DATA_LOADED_EVENT, this.setUserAvatar.bind(this));
		});
	}

	setUserAvatar() {
		if (!this.sl.userDataService.lmsUserData || !this.sl.userDataService.lmsUserData.avatar) {
			return;
		}

		const $userAvatars = document.querySelectorAll('.site-user-avatar');
		$userAvatars.forEach(($userAvatar) => {
			if ($userAvatar.classList.contains('lozad') && $userAvatar.dataset.loaded !== 'true') {
				$userAvatar.dataset.src = `${Api.lmsUrl}/${this.sl.userDataService.lmsUserData.avatar}?width=100&height=100`;
			} else {
				$userAvatar.src = `${Api.lmsUrl}/${this.sl.userDataService.lmsUserData.avatar}?width=100&height=100`;
			}
		});
	}

	bootstrap() {
		if (this.media) {
			this.initDesktop();
		} else {
			this.initMobile();
		}

		this.initPinnedNavModule();
		this.addEventListeners();

		this.sl.eventEmitterService.emit('event:header-loaded');
		this.sl.headerLoaded = true;
	}

	addEventListeners() {
		window.addEventListener('resize', throttle(() => {
			this.media = window.matchMedia('(min-width: 769px)').matches;

			if (this.media && !this.desktopInitialized) {
				this.initDesktop();
			} else if (!this.media && !this.mobileInitialized) {
				this.initMobile();
			}
		}, 20));
	}

	initDesktop() {
		this.desktopInitialized = true;
		this.initHeaderDropdownService();
		this.courseMenuLoader.loadDesktopCourseMenu(this.dropdownService);
	}

	initMobile() {
		this.mobileInitialized = true;
		this.initMobileNavModule();
		this.courseMenuLoader.loadMobileCourseMenu(this.mobileNavModule);
	}

	initHeaderDropdownService() {
		this.dropdownService = new HeaderDropdownService(this.$root);
	}

	initPinnedNavModule() {
		const pinnedNavModule = new PinnedNavModule(this.$root);
	}

	initMobileNavModule() {
		this.mobileNavModule = new MobileNavModule(this.$mobileNavMenuTrigger);
	}
}